// originally from crud-ad-style in ui-next/common-styles
import type { PreviewStyleOptions } from './extension-preview-styles';

export const getCrudAdImagePreviewStyles = (_: unknown, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }: PreviewStyleOptions) => ({
  '& .new-preview-carousel-container': {
    border: '1px solid #C8C8C8',
    margin: 0,
    width: '100%',
    minWidth: 669,

    '& .preview-header': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',

      '& .ad-preview-title.with-additional-tag': {
        marginRight: 8,
        display: 'inline-block',
        flexGrow: 0,
      },

      '& .flex-grow': {
        flexGrow: 1,
      },

      '& .ad-preview-actions.inline-title': {
        display: 'inline-block',
        flexGrow: 0,
        marginRight: 16,
      },
    },

    '& .ad-preview-title': {
      fontSize: 18,
      fontWeight: 'normal',
      lineHeight: '24px',
      margin: '20px 24px 16px 24px',
      '&.with-additional-tag': {
        marginRight: 8,
        display: 'inline-block',
      },
    },

    '& .improve-mma-title-container': {
      marginTop: 14,
      marginLeft: 24,
      '& .iconba.iconba-Lightbulb.new-preview-carousel': {
        color: palette.accent,
        fontSize: 16,
        marginRight: 3,
      },
    },

    '& .ad-preview-actions': {
      textAlign: 'center',

      '& span.action-label': {
        fontSize: 16,
        lineHeight: 2,
        marginRight: 16,
      },
    },

    '& .carousel-inner': {
      paddingBottom: 64,
      '& > .item.active': {
        paddingLeft: 24,
        paddingRight: 24,
      },
    },

    '& ol.carousel-indicators': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      margin: '20px 24px',
      width: 'auto',

      '& li': {
        background: 'none',
        border: '1px solid #605E5C',
        borderRadius: 10,
        margin: '0 10px 0 0',
        height: 10,
        width: 10,
      },

      '& li.active': {
        background: palette.themePrimary,
        border: `1px solid ${palette.themePrimary}`,
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          border: '5px solid ButtonText',
        },
      },
    },

    '& .carousel-controls': {
      display: 'none',
    },

    '& .carousel-control': {
      color: palette.themePrimary,
      position: 'absolute',
      left: 'auto',
      top: 'auto',
      right: 0,
      bottom: 0,
      height: 32,
      width: 20,
      margin: '20px 24px',
      textShadow: 'none',

      '&:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
      },

      '&.left': {
        marginRight: 76,
      },

      '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
        fontFamily: iconFontFamily,
        position: 'relative',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        margin: 0,
        fontSize: 16,
        lineHeight: 1,
        verticalAlign: 0,
      },
    },

    '& .boost-carousel': {
      '& .carousel-control.right': {
        position: 'absolute',
        left: 190,
        bottom: -7,
      },
    },

    '& .boost-carousel-new-support': {
      '& .carousel-control.right': {
        position: 'absolute',
        left: 330,
        bottom: -7,
      },
    },

    '& .new-carousel-navigation': {
      '& .carousel-control.left': {
        position: 'absolute',
        left: 0,
        marginLeft: 15,
        bottom: -7,
      },
      '& .carousel-control.right': {
        position: 'absolute',
        left: 45,
        bottom: -7,
      },
      '& .carousel-indicators': {
        left: 20,
      },
    },

    '& .new-carousel-navigation-mma': {
      '& .carousel-control.left': {
        position: 'absolute',
        left: 0,
        marginLeft: 15,
        bottom: -7,
      },
      '& .carousel-control.right': {
        position: 'absolute',
        left: 0,
        bottom: -7,
      },
      '& .carousel-indicators': {
        left: 20,
      },
    },

    '& .new-carousel-navigation .carousel-control.right': {
      marginLeft: 155,
    },

    '& .new-carousel-navigation-v2 .carousel-control.right': {
      marginLeft: 230,
    },


    '& .new-carousel-navigation-mma .carousel-control.right': {
      marginLeft: 135,
    },

    '& .new-carousel-navigation-mma .carousel-inner > .item.active': {
      paddingLeft: 0,
      paddingRight: 0,
    },

    '& .new-responsive-ad-preview-container': {
      height: 500,
      overflow: 'hidden',

      '& .responsive-ad-preview-content': {
        border: '1px solid #C8C8C8',

        '& .ad-logo': {
          width: 'auto',
          padding: '0 4px',
          marginRight: 4,

          '& p': {
            margin: 0,
            position: 'relative',
            top: 0,
          },
        },

        '& .business-name': {
          height: 'auto',
          padding: 0,
        },
      },

      '& .preview-type-string': {
        bottom: 50,
        fontSize: 14,
        lineHeight: '20px',
        paddingTop: 12,
      },

      '& .video-ad-preview-type-name': {
        fontSize: 22,
        position: 'absolute',
        bottom: 20,
        transform: 'translateX(-50%)',
        left: '50%',
      },
    },

    '& .new-responsive-ad-preview-container.preview-16-9-homepage, & .new-responsive-ad-preview-container.preview-16-9-infopane': {
      '& .responsive-video-ad-preview-content': {
        boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.13), 0px 0px 2.9px rgba(0, 0, 0, 0.11)',
      },
      '& .responsive-ad-preview-content': {
        '& > div > div:nth-child(3)': {
          color: 'white',
          '& i': {
            marginTop: 12,
            marginBottom: 12,
          },
          '& i:first-child': {
            marginLeft: 16,
          },
          '& i:last-child': {
            marginRight: 16,
          },
          '& .ms-Slider-container': {
            marginLeft: 16,
            marginRight: 16,
          },
        },
        '& .responsive-ad-preview-content-link': {
          color: 'inherit',
        },
        '& .responsive-ad-preview-content-link:hover': {
          textDecoration: 'none',
        },
      },
      '& .video-ad-preview-shadow': {
        background: 'linear-gradient(transparent, black)',
        position: 'absolute',
        bottom: 0,
        height: 150,
        width: '100%',
        pointerEvents: 'none',
        transition: 'opacity 0.3s',
      },
      // Video control styles
      '& video::-webkit-media-controls-panel': {
        background: '0 0',
      },
      '& video::-webkit-media-controls-fullscreen-button': {
        display: 'none',
      },

      '& .text-container': {
        position: 'absolute',
        marginBottom: 50,
        color: 'white',
        '& .long-headline .multi-line-processed-text': {
          fontSize: 28,
          lineHeight: '34px',
        },
        '& .multi-line-processed-text': {
          height: 40,
        },
        '& .business-name-with-ads': {
          marginTop: 13,
          '& .adslabel': {
            fontSize: 10,
            borderRadius: '4px',
            background: '#107C10',
            height: 16,
            padding: '2px 4px 2px 4px',
          },
        },
      },
    },

    '& .new-responsive-ad-preview-container.preview-16-9-inarticlead': {
      '& .responsive-video-ad-preview-content': {
        boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.13), 0px 0px 2.9px rgba(0, 0, 0, 0.11)',
      },
      '& .responsive-ad-preview-content': {
        '& > div > div:nth-child(3)': {
          color: 'white',
          '& i': {
            marginTop: 12,
            marginBottom: 12,
          },
          '& i:first-child': {
            marginLeft: 16,
          },
          '& i:last-child': {
            marginRight: 16,
          },
          '& .ms-Slider-container': {
            marginLeft: 16,
            marginRight: 16,
          },
        },
        '& .responsive-ad-preview-content-link': {
          color: 'inherit',
        },
        '& .responsive-ad-preview-content-link:hover': {
          textDecoration: 'none',
        },
      },
      // Video control styles
      '& video::-webkit-media-controls-current-time-display, & video::-webkit-media-controls-time-remaining-display, & video::-webkit-media-controls-fullscreen-button': {
        display: 'none',
      },

      '& .text-container': {
        padding: 8,
        '& .long-headline ': {
          '& .multi-line-processed-text': {
            fontSize: 14,
            lineHeight: '20px',
            color: '#2B2B2B',
          },
        },
        '& .multi-line-processed-text': {
          height: 40,
        },
        '& .business-name-with-ads': {
          position: 'absolute',
          bottom: 8,
          '& .adslabel': {
            fontSize: 10,
            borderRadius: '4px',
            background: '#107C10',
            height: 16,
            padding: '2px 4px 2px 4px',
          },
          '& .business-name': {
            color: '#555555',
          },
        },
      },
    },

    '& .disclaimer-info, & .additional-disclaimer': {
      fontSize: 12,
      lineHeight: '20px',
      textAlign: 'left',
    },

    '& .disclaimer-info': {
      padding: '0 24px 20px 24px',
    },

    '& .additional-disclaimer': {
      bottom: 0,
      padding: '0 24px',
    },

    '& button.view-placements': {
      position: 'absolute',
      right: 20,
      bottom: 70,
      color: palette.themePrimary,
    },
    '& button.view-placements .iconba': {
      top: 1,
      fontSize: 16,
    },
  },
});
